import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/documents', request)
}

async function post(request) {
    return await postMethod('/api/documents', request)
}

async function put(id, request) {
    return await putMethod(`/api/documents/${id}`, request)
}

export {get, post, put}
